export default __webpack_public_path__ + "static/media/DailyActivities.8adfdbde.svg";